class VideoResponser extends HTMLElement {
  constructor() {
    super();
    this.video = this.querySelector('video');
    this.init();
  }

  init() {
    if (!this.video) return;

    this.setupResponsiveVideo();
    this.setupIntersectionObserver();
  }

  setupResponsiveVideo() {
    const sources = this.video.querySelectorAll('source[data-src]');
    const currentWidth = window.innerWidth;

    sources.forEach(source => {
      source.removeAttribute('src');
    });

    // Find the best matching source based on screen width
    let bestSource = null;

    sources.forEach(source => {
      const maxWidth = parseInt(source.getAttribute('data-mw'), 10);
      const dataSrc = source.getAttribute('data-src');

      // For mobile: use sources with data-mw=200 if screen width <= 768
      // For desktop: use sources with data-mw=480 if screen width > 768
      if (maxWidth) {
        if ((currentWidth <= 768 && maxWidth === 200) ||
          (currentWidth > 768 && maxWidth === 480)) {
          if (!bestSource || dataSrc.includes('.mp4')) {
            bestSource = source;
          }
        }
      } else if (!bestSource) {
        // Fallback to source without data-mw if no better match
        bestSource = source;
      }
    });

    if (bestSource) {
      bestSource.src = bestSource.getAttribute('data-src');
    }

    if (!bestSource && this.video.hasAttribute('data-src')) {
      this.video.src = this.video.getAttribute('data-src');
    }

    // Handle resize events for responsive behavior
    if (!this.resizeListenerAdded) {
      window.addEventListener('resize', this.debounce(() => {
        this.setupResponsiveVideo();
        this.video.load();
      }, 250));
      this.resizeListenerAdded = true;
    }
  }

  setupIntersectionObserver() {
    const options = {
      threshold: 0.1,
      rootMargin: '50px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.loadVideo();
          observer.unobserve(this);
        }
      });
    }, options);

    observer.observe(this);
  }

  loadVideo() {
    this.setupResponsiveVideo();
    this.video.load();

    // Wait for video to be ready before attempting autoplay
    const attemptAutoplay = () => {
      if (this.video.hasAttribute('autoplay') && this.video.hasAttribute('muted')) {
        this.video.play().catch(error => {
          console.log('Video autoplay failed:', error);
        });
      }
    };

    if (this.video.readyState >= 1) {
      attemptAutoplay();
    } else {
      this.video.addEventListener('loadedmetadata', attemptAutoplay, { once: true });
    }
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

customElements.define('video-responser', VideoResponser);